<template>
  <v-chip :color="color">
    <v-avatar v-if="icon.left" left @click="$emit('left-action')" class="pointer">
      <v-icon>
        {{ icon.left }}
      </v-icon>
    </v-avatar>
    {{ text }}
    <v-avatar v-if="icon.right" right @click="$emit('right-action')" class="pointer">
      <v-icon>
        {{ icon.right }}
      </v-icon>
    </v-avatar>
  </v-chip>
</template>

<script>
  export default {
    props: [
      "color",
      "icon",
      "text"
    ]
  }
</script>